import o, { useState, useEffect } from 'react';
import { useCampaignContext } from './src-hooks-useCampaignContext.js';
import { StyledCallout, StyledText } from './src-components-CampaignCallouts.styles.js';
import { isPricingContextInitialized, getPricingContextCouponCode } from './src-utils-pricingContext.js';

const CampaignCallout = o.forwardRef(
  ({ developmentMode, ...props }, ref) => {
    const { callouts, locale, skin } = useCampaignContext();
    const [couponCode, setCouponCode] = useState("");
    const [overridenSkin, setOverridenSkin] = useState("info");
    const [overridenVariant, setOverridenVariant] = useState("standard");
    useEffect(() => {
      if (skin !== "") {
        switch (skin) {
          case "standard":
            setOverridenSkin("info");
            setOverridenVariant("standard");
            break;
          case "holidayInverse":
            setOverridenSkin("holiday");
            setOverridenVariant("inverse");
            break;
          case "announcementInverse":
            setOverridenSkin("promo");
            setOverridenVariant("inverse");
            break;
        }
      }
    }, [skin]);
    const pricingContextInitialized = isPricingContextInitialized(developmentMode);
    useEffect(() => {
      if (pricingContextInitialized) {
        setCouponCode(getPricingContextCouponCode());
      }
    }, [pricingContextInitialized]);
    if (!callouts) {
      return /* @__PURE__ */ o.createElement(o.Fragment, null);
    }
    const calloutForProduct = callouts[props.product];
    if (!calloutForProduct || !locale) {
      return /* @__PURE__ */ o.createElement(o.Fragment, null);
    }
    return /* @__PURE__ */ o.createElement(o.Fragment, null, couponCode === "" && /* @__PURE__ */ o.createElement(
      StyledCallout,
      {
        ...props,
        skin: overridenSkin,
        variant: overridenVariant,
        ref
      },
      /* @__PURE__ */ o.createElement(StyledText, null, calloutForProduct)
    ));
  }
);
CampaignCallout.displayName = "CampaignCallout";

export { CampaignCallout as default };
//# sourceMappingURL=src-components-CampaignCallout.js.map
